var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:{'loading': _vm.loading, 'hide-text': _vm.hideText},attrs:{"type":_vm.type,"variant":_vm.variant},on:{"click":_vm.callRegisteredAction}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }